// @flow

import throttle from 'lodash.throttle';
import styles from '../insert-column-button.module.styl';

import type {
    ObserverConfig,
    OnMouseMove,
    Subscribe
} from '../typedef';


const MOUSE_MOVE_DELAY = 100;
const WHEEL_DELAY = 50;
const TIMER_DELAY = 75;


export class MouseMoveObserver {
    _arrCallback: Array<OnMouseMove> = [];
    _timer: TimeoutID | null = null;
    _isScrolling: boolean = false;

    _config: ObserverConfig = {
        excludeClasses: [styles.insert_column_button__button]
    };

    constructor(config?: ObserverConfig) {
        if (config) {
            this._config = config;
        }
    }

    init = (element: HTMLElement) => {
        element.addEventListener('mousemove', this._onMouseMove);
        element.addEventListener('mouseleave', this._onMouseLeave);
        element.addEventListener('wheel', this._onWheel);
    };

    destroy = (element: HTMLElement) => {
        element.removeEventListener('mousemove', this._onMouseMove);
        element.removeEventListener('mouseleave', this._onMouseLeave);
        element.removeEventListener('wheel', this._onWheel);
    };

    subscribe: Subscribe = callback => {
        this._arrCallback.push(callback);

        return () => {
            this._arrCallback.filter(prevCallback => prevCallback !== callback);
        };
    };

    _onMouseMove = throttle((event: MouseEvent) => {
        if (!this._isScrolling) {
            const {pageX, pageY} = event;

            this._arrCallback.forEach(callback => {
                callback({pageX, pageY});
            });
        }
    }, MOUSE_MOVE_DELAY);

    _onHide = () => {
        this._onMouseMove.cancel();

        this._arrCallback.forEach(callback => {
            callback({pageX: null, pageY: null});
        });
    };

    _onMouseLeave = (event: MouseEvent) => {
        const target = event.relatedTarget;
        const classes = this._config?.excludeClasses || [];

        if (target instanceof HTMLElement && !classes.some(
            className => target.classList.contains(className)
        )) {
            this._onHide();
        }
    };

    _onWheel = throttle(() => {
        clearTimeout(this._timer);

        this._isScrolling = true;
        this._onHide();

        this._timer = setTimeout(() => {
            this._isScrolling = false;
        }, TIMER_DELAY);
    }, WHEEL_DELAY);
}

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
